export default "__VITE_ASSET__rVCsFext__"